import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { useIntl } from 'react-intl';

import ScheduleType from './ScheduleType';

import { isLeague } from '../lib';

import { useTeamSchedules } from '../queries/schedules'
import { useLocale } from '../i18n';
import { AdsComponent } from './Ads.component';

export const Option = ({ label, ...props }) => {
  const [ locale ] = useLocale();
  const { schedule, group } = props.data;
  let name = schedule.name;
  if (group) name = `${schedule.name} - ${group.name}`
  return <components.Option {...props}>
    {name}
    <div style={{ fontSize: 12 }}>
      <ScheduleType schedule={schedule} locale={locale} />
    </div>
  </components.Option>
}

const ScheduleFilter = ({ schedules, filters, onSelect, ...props }) => {
  const { formatMessage } = useIntl();

  const options = [{
    label: formatMessage({ id: 'common.lang.leagues' }),
    options: schedules.filter(result => isLeague(result.schedule))
  }, {
    label: formatMessage({ id: 'common.lang.tournaments' }),
    options: schedules.filter(result => !isLeague(result.schedule))
  }]

  const getValue = () => {
    const { scheduleId, groupId } = filters;
    if (!scheduleId) return;
    return { scheduleId, groupId }
  }

  const value = getValue()

  const getOptionLabel = (schedule) => schedule.name
  const getOptionValue = (option) => option
  const isOptionDisabled = (option, values) => false
  const isOptionSelected = (option, values) => values.some(value => option.scheduleId == value.scheduleId && option.groupId == value.groupId)
  const filterOption = (option, inputValue) => true
  const formatOptionlabel = (option, context) => {
    const result = option.id ? option : schedules.find(schedule => schedule.scheduleId == option.scheduleId && schedule.groupId == option.groupId)
    if (!result) return;

    const { schedule, group } = result;
    if (!group) return getOptionLabel(schedule);
    if (isLeague(schedule)) return `${schedule.name} - ${group.name}`
    return `${schedule.name} - ${group.name}`
  }

  return <div className="filter filter-scheduleId d-inline-block">
    <Select
      className="mr-3"
      name="scheduleId"
      placeholder={formatMessage({ id: 'common.lang.schedule' })}
      value={[value]}
      isSearchable={false}
      isClearable

      onChange={onSelect}
      filterOption={filterOption}
      formatOptionLabel={formatOptionlabel}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isOptionDisabled={isOptionDisabled}
      isOptionSelected={isOptionSelected}
      noOptionsMessage={() => formatMessage({ id: 'common.lang.no.options' })}

      options={options}
      components={{ Option }}
      {...props}
    />
  </div>
}

export default ({ teamId, team, initialValues, children, ...props }) => {
  const { data: schedules = [], isLoading } = useTeamSchedules(teamId);

  const [ filters, setFilter ] = useState(initialValues)

  useEffect(() => {
    // automatically select the only option or league if applicable
    if (!schedules?.length) return;
    if (filters.scheduleId && schedules.some(s => s.scheduleId == filters.scheduleId && s.groupId == filters.groupId)) return;

    if (schedules.length == 1) {
      const [ schedule ] = schedules;
      setFilter(filter => ({
        ...filter,
        scheduleId: schedule.scheduleId,
        groupId: schedule.groupId,
      }))
      return;
    }
    const regular = schedules.find(s => s.schedule.type === 'League')
    if (regular) {
      setFilter(filter => ({
        ...filter,
        scheduleId: regular.scheduleId,
        groupId: regular.groupId,
      }))
    }
  }, [ schedules, filters.scheduleId, filters.groupId ])

  const handleSelect = option => {
    setFilter(filters => ({
      ...filters,
      scheduleId: option ? option.scheduleId : undefined,
      groupId: option ? option.groupId: undefined,
    }))
  }

  return <>
    <div className="team-filters my-3">
      <ScheduleFilter schedules={schedules} filters={filters} onSelect={handleSelect} isLoading={isLoading} />
    </div>
    <AdsComponent />
    { React.cloneElement(children, {
      teamId,
      filters,
      data: {
        team,
        schedules,
        groups: schedules.map(schedule => schedule.group).filter(Boolean),
      },
      ...props,
    })}
  </>
}
